import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import WkcLeaveHead from '@/types/table/wkcLeaveHead';
import { DictData, DictionaryBase } from '@/common/staticDict/types';
import { OvertimeHoursData } from '@/api/generated/overtimeHoursController';
// import { FlowWorkOrderData } from '@/api/generated/flowWorkOrderController';
import { WkcLeaveFertilityData } from '@/api/generated/wkcLeaveFertilityController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface WkcLeaveHeadData extends WkcLeaveHead {
  overtimeHours?: OvertimeHoursData;
  // flowWorkOrder?: FlowWorkOrderData;
  wkcLeaveFertility?: WkcLeaveFertilityData;
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class WkcLeaveHeadController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<WkcLeaveHeadData>>(API_CONTEXT + '/app/wkcLeaveHead/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<WkcLeaveHeadData>(API_CONTEXT + '/app/wkcLeaveHead/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/wkcLeaveHead/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/wkcLeaveHead/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/wkcLeaveHead/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcLeaveHead/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcLeaveHead/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcLeaveHead/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcLeaveHead/deleteBatch', params, httpOptions);
  }
  static startOnlyFlowLeave(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcLeaveHead/startOnly/flowLeave', params, httpOptions);
  }
  static startWithBusinessKeyFlowLeave(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcLeaveHead/startWithBusinessKey/flowLeave', params, httpOptions);
  }
  static startAndTakeUserTaskFlowLeave(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcLeaveHead/startAndTakeUserTask/flowLeave', params, httpOptions);
  }
  static editorTakeUserTaskFlowContract(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcLeaveHead/editorTakeUserTaskFlowContract/editorTakeUserTaskFlowContract', params, httpOptions);
  }
  static startAndSaveDraftFlowLeave(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcLeaveHead/startAndSaveDraft/flowLeave', params, httpOptions);
  }
  static submitUserTaskFlowLeave(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcLeaveHead/submitUserTask/flowLeave', params, httpOptions);
  }
  static viewTaskBusinessDataFlowLeave(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/wkcLeaveHead/viewTaskBusinessData/flowLeave', params, httpOptions);
  }
  static viewHistoricTaskBusinessDataFlowLeave(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/wkcLeaveHead/viewHistoricTaskBusinessData/flowLeave', params, httpOptions);
  }
  static listWorkOrderFlowLeave(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcLeaveHead/listWorkOrder/flowLeave', params, httpOptions);
  }
  static getUserOvertimeHoursFlowLeave(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/wkcLeaveHead/getUserOvertimeHours/flowLeave', params, httpOptions);
  }
  static getHolidaysFlowLeave(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/wkcLeaveHead/getHolidays/flowLeave', params, httpOptions);
  }

 static getConfigurationHolidays(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/wkcLeaveHead/getConfigurationHolidays/getConfigurationHolidays', params, httpOptions);
  }

  static uploadFileFlowLeave(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcLeaveHead/uploadFile/flowLeave', params, httpOptions);
  }
  static getLeaveTypeList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return new Promise<DictionaryBase>((resolve, reject) => {
          super.get<DictData[]>(API_CONTEXT + '/app/wkcLeaveHead/getLeaveTypeList', params, httpOptions)
            .then(res => {
              const dictData = new DictionaryBase('请假类型', res.data);
              resolve(dictData);
            })
            .catch(err => {
              reject(err);
            });
        });
  }
  static getLeaveExplainList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return new Promise<DictionaryBase>((resolve, reject) => {
      super.get<DictData[]>(API_CONTEXT + '/app/wkcLeaveHead/getLeaveExplainList', params, httpOptions)
        .then(res => {
          const dictData = new DictionaryBase('请假说明', res.data);
          resolve(dictData);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  static getMaternityLeave(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/wkcLeaveHead/getMaternityLeave/flowLeave', params, httpOptions);
  }
  static updateLeaveEndTime(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcLeaveHead/updateLeaveEndTime', params, httpOptions);
  }
  static materialsResubmissionAndUpdate(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcLeaveHead/materialsResubmissionAndUpdate/flowLeave', params, httpOptions);
  }
    static deleteMessage(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dept/deleteMessage', params, httpOptions);
  }

  static getUserInformation(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcLeaveHead/getUserInformation', params, httpOptions);
  }

}
